import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { AdminPagination } from './AdminPagination';
import { formatDateFor } from './adminUtils';

export const AdminReportsTab = ({ reports, page, setPage, pageSize, language }) => {
  const tr = language === 'tr';
  const formatDate = formatDateFor(language);
  return (
    <Card className="bg-slate-900/50 border-slate-800" data-testid="admin-reports-tab">
      <CardHeader>
        <CardTitle className="text-white">{tr ? 'Rapor Listesi' : 'Report List'}</CardTitle>
        <CardDescription className="text-slate-400">
          {tr ? `Toplam ${reports.total} rapor` : `Total ${reports.total} reports`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-slate-700">
              <TableHead className="text-slate-400">{tr ? 'Şirket' : 'Company'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Kullanıcı' : 'User'}</TableHead>
              <TableHead className="text-slate-400">GDMII</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Pozisyon' : 'Position'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Tarih' : 'Date'}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {reports.reports.map((r) => (
              <TableRow key={r.id} className="border-slate-700">
                <TableCell className="text-white">{r.company_name}</TableCell>
                <TableCell className="text-slate-300">{r.user_email}</TableCell>
                <TableCell className="text-white font-medium">{r.gdmii_score?.toFixed(1) || '-'}</TableCell>
                <TableCell className="text-slate-300 capitalize">{r.benchmark_position?.replace('_', ' ') || 'N/A'}</TableCell>
                <TableCell className="text-slate-400 text-xs">{formatDate(r.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <AdminPagination page={page} setPage={setPage} total={reports.total} pageSize={pageSize} testId="reports-pagination" />
      </CardContent>
    </Card>
  );
};
